import React from 'react';
import { TranslateContext } from 'core/translate';
import ControlButton from './ControlButton';

const ZoomButton = ({ isVisible, onClick, text, className }) => {
  return (
    <TranslateContext.Consumer>
      {translate => (
        <ControlButton
          text={translate(text)}
          screenReaderText={translate('component.cgi.enlarge.label')}
          icon="expand"
          isVisible={isVisible}
          analyticsKey="enlarge"
          onClick={onClick}
          className={className}
        />
      )}
    </TranslateContext.Consumer>
  );
};

export default ZoomButton;
